  import { motion } from 'framer-motion';

import bespokeImage from "../assets/bespoke.png";



const BespokePortfolios: React.FC = () => {



 return (
 <section className="py-24 bg-white overflow-hidden ml-8">
 <div className="max-w-7xl mx-auto px-6 lg:px-24">
 <div className="grid grid-cols-1 lg:grid-cols-12 gap-26 items-center ml-8">
 

{/* LEFT SIDE: CONTENT (Same Structure as Bonds Section) */}
<motion.div
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  className="lg:col-span-5"
>
  

  <div className="space-y-6 max-w-xl">
    <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
      Every financial journey is distinct. A bespoke portfolio begins with a clear understanding of your risk appetite, liquidity priorities, and long-term objectives.
    </p>

    <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
    Rather than applying standard allocation models, exposure should be structured across suitable investment avenues in alignment with one’s financial landscape — balancing growth, preservation, and continuity with discipline.
    </p>

    <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-8 italic">
      Disciplined allocation. Continuous monitoring. Balanced growth.
    </p>
  </div>
</motion.div>


<motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="lg:col-span-7 flex justify-center items-center"
          >
            <div className="relative w-full max-w-[550px]">
              <img 
                src={bespokeImage} 
                alt="Portfolio Universe Bespoke Wheel" 
                className="w-full h-auto object-contain"
              />
            </div>
          </motion.div>

{/*
 <div className="lg:col-span-7 relative flex justify-center items-center h-[600px]">

 <div
className="absolute border-2 border-slate-300 rounded-full "


 style={{ width: size, height: size }}
 />

 <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
<div className="text-center">
 <h2 className="text-2xl font-syne font-extrabold text-slate-900 tracking-tighter leading-tight">
 PORTFOLIO <br /> UNIVERSE
 </h2>
</div>
</div>

{services.map((service, idx) => {
 const angleRad = (service.angle * Math.PI) / 180;
 const x = radius * Math.cos(angleRad);
 const y = radius * Math.sin(angleRad);

 return (
 <div
 key={idx}
className="absolute flex flex-col items-center group"
 style={{ 
 left: `calc(50% + ${x}px)`, 
 top: `calc(50% + ${y}px)`,
 transform: 'translate(-50%, -50%)'
 }}
 >
 <div
 className={`w-14 h-14 rounded-full ${service.color} border border-slate-200 flex items-center justify-center transition-all duration-300 group-hover:bg-slate-200`}
>
 <service.icon className="w-6 h-6 text-white" strokeWidth={1.5} />

 </div>
 <span className="mt-3 text-[10px] font-semibold tracking-wide text-slate-600 uppercase">

 {service.label}
</span>
</div>
 );
 })}
 </div>
*/}
</div>
</div>
 </section>
 );
};

export default BespokePortfolios;